export default __webpack_public_path__ + "static/media/american-express.7ef6874f.svg";